import { render } from "./ProjectProcureAttachmentOffcanvas.vue?vue&type=template&id=76207e92&scoped=true&ts=true"
import script from "./ProjectProcureAttachmentOffcanvas.ts?vue&type=script&lang=ts"
export * from "./ProjectProcureAttachmentOffcanvas.ts?vue&type=script&lang=ts"

import "./ProjectProcureAttachmentOffcanvas.scss?vue&type=style&index=0&id=76207e92&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76207e92"]])

export default __exports__